<template>
  <div>
    <el-tabs
      tab-position="left"
      v-model="activeName"
      style="padding: 90px 0 90px 0"
      @tab-click="handleClick"
    >
      <el-tab-pane label="南京（江北）" name="activeJb">
        <div class="introduction">
          <div class="left">
            <el-carousel trigger="click" height="400px">
              <el-carousel-item
                v-for="(item, index) in swiperListJb"
                :key="index"
              >
                <img :src="item" style="width: 100%; height: 100%" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="right">
            <div class="right-content">
              <p class="title">江河华晟医学旗下南京江北实验室简介</p>
              <p class="intro">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                南京江北实验室为江河华晟医学全国总部，位于南京江北新区生物医药谷“中丹生态生命科学园”内，于2020
                年10
                月顺利通过各项竣工验收。该实验室共计两层楼，包含临床实验室、病理实验室，总面积超过5000
                平米，配备了国际先进、国内一流的检验检测相关的医 疗设备。
              </p>
              <p class="intro">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                伴随南京江宁、南京江北、长沙、郑州4
                家实验室的相继投资建设，江河华晟医学的全国化战略布局也在逐步打开。一方面公司将继续加强总部建设，将总部实验室打造成为技术领先、服务领先、效率最优的新型标杆实验室；另一方面，也将有序、高效地推进外省实验室的建设，以数智驱动和技术赋能，加速推进“互联网+基层医疗”战略的落地，矢志赋能20家基层医疗机构，为2亿国民提供专业、全面的健康管理服务，为建设健康中国、实现中华民族伟大复兴的中国梦贡献一份江河华晟力量。
              </p>
              <!-- <P class="intro"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                面向未来，华晟医学检验实验室秉承“专业创新、精益求精、服务为先、客户至上”的服务宗旨，不断弘扬“诊断指导治疗”的价值理念，不断践行“让诊断更准确，让医检更便捷”的初心，矢志成为中国第三方医学检验行业的创新引领者，赋能基层医疗，助力公共卫生，护卫百姓健康，与健康中国同行。</P
              > -->
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="南京（江宁）" name="activeJn">
        <div class="introduction">
          <div class="left">
            <el-carousel trigger="click" height="400px">
              <el-carousel-item
                v-for="(item, index) in swiperListJn"
                :key="index"
              >
                <img :src="item" style="width: 100%; height: 100%" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="right">
            <div class="right-content">
              <p class="title">江河华晟医学旗下南京江宁实验室简介</p>
              <p class="intro">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 南京江宁实验室成立于2018
                年4
                月，位于南京市江宁区生命科技小镇，是江河华晟医学首家自主投资建设的现代化全科实验室，总建设面积2000平米，于2020
                年2 月获批为南京市新型冠状病毒核酸定点检测机构。
              </p>
              <!-- <P class="intro"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                凭借国际领先的检验诊断设备、业界一流的技术人才，华晟医学检验实验室顺利通过了江苏省临床基因检验（PCR）实验室合格验收、南京市卫健委HIV初筛实验室、南京市新型冠状病毒核酸检测定点筛查机构、南京市医保定点医疗机构等资质认证和权威认可。华晟医学检验实验室自成立以来，一直积极参加国家卫健委临床检验中心、江苏省临床检验中心举办的年度室间质评活动，且各项质评成绩优秀。
              </P>
              <P class="intro"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                面向未来，华晟医学检验实验室秉承“专业创新、精益求精、服务为先、客户至上”的服务宗旨，不断弘扬“诊断指导治疗”的价值理念，不断践行“让诊断更准确，让医检更便捷”的初心，矢志成为中国第三方医学检验行业的创新引领者，赋能基层医疗，助力公共卫生，护卫百姓健康，与健康中国同行。</P
              > -->
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="长沙" name="activeChs">
        <div class="introduction">
          <div class="left">
            <el-carousel trigger="click" height="400px">
              <el-carousel-item
                v-for="(item, index) in swiperListChs"
                :key="index"
              >
                <img :src="item" style="width: 100%; height: 100%" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="right">
            <div class="right-content">
              <p class="title">江河华晟医学旗下长沙实验室简介</p>
              <p class="intro">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                长沙实验室位于长沙市岳麓区湖南省检验检测特色产业园，已于2021
                年5月底完成竣工验收，是按照国内先进的标准实验室规格要求建设，建筑面积约为3800
                平米。该实验室是江河华晟医学在外省首家投资兴建的现代化全科实验室。
              </p>
              <!-- <P class="intro"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                凭借国际领先的检验诊断设备、业界一流的技术人才，华晟医学检验实验室顺利通过了江苏省临床基因检验（PCR）实验室合格验收、南京市卫健委HIV初筛实验室、南京市新型冠状病毒核酸检测定点筛查机构、南京市医保定点医疗机构等资质认证和权威认可。华晟医学检验实验室自成立以来，一直积极参加国家卫健委临床检验中心、江苏省临床检验中心举办的年度室间质评活动，且各项质评成绩优秀。
              </P>
              <P class="intro"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                面向未来，华晟医学检验实验室秉承“专业创新、精益求精、服务为先、客户至上”的服务宗旨，不断弘扬“诊断指导治疗”的价值理念，不断践行“让诊断更准确，让医检更便捷”的初心，矢志成为中国第三方医学检验行业的创新引领者，赋能基层医疗，助力公共卫生，护卫百姓健康，与健康中国同行。</P
              > -->
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="郑州" name="activeZhzh">
        <div class="introduction">
          <div class="left">
            <el-carousel trigger="click" height="400px">
              <el-carousel-item
                v-for="(item, index) in swiperListZHzh"
                :key="index"
              >
                <img :src="item" style="width: 100%; height: 100%" alt="" />
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="right">
            <div class="right-content">
              <p class="title">江河华晟医学旗下郑州实验室简介</p>
              <p class="intro">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                郑州实验室位于郑州经济技术开发区，该实验室已于9月16日完成竣工验收，是按照国内先进的标准实验室规格要求建设，建筑面积约为3030
                平米。该实验室是江河华晟医学在河南省投资兴建的首家现代化全科实验室。
              </p>
              <!-- <P class="intro"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                凭借国际领先的检验诊断设备、业界一流的技术人才，华晟医学检验实验室顺利通过了江苏省临床基因检验（PCR）实验室合格验收、南京市卫健委HIV初筛实验室、南京市新型冠状病毒核酸检测定点筛查机构、南京市医保定点医疗机构等资质认证和权威认可。华晟医学检验实验室自成立以来，一直积极参加国家卫健委临床检验中心、江苏省临床检验中心举办的年度室间质评活动，且各项质评成绩优秀。
              </P>
              <P class="intro"
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                面向未来，华晟医学检验实验室秉承“专业创新、精益求精、服务为先、客户至上”的服务宗旨，不断弘扬“诊断指导治疗”的价值理念，不断践行“让诊断更准确，让医检更便捷”的初心，矢志成为中国第三方医学检验行业的创新引领者，赋能基层医疗，助力公共卫生，护卫百姓健康，与健康中国同行。</P
              > -->
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <div class="middle">
      <div class="middle-content">
        <img
          src="../../../../../static/image/lab2.png"
          alt=""
          style="width: 100%; height: 100%"
        />
      </div>
    </div>
    <div class="bottom">
      <div class="bottom-content">
        <img
          src="../../../../../static/image/lab3.png"
          alt=""
          style="width: 100%; height: 100%"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'activeJb',
      initialIndexJb: 0,
      initialIndexJn: 0,
      initialIndexChs: 0,
      initialIndexZhzh: 0,
      swiperListJb: [
        '../../../../../static/image/shys/jb01.jpg',
        // '../../../../../static/image/shys/jb02.jpg',
        '../../../../../static/image/shys/jb03.jpg',
        '../../../../../static/image/shys/jb04.jpg',
        '../../../../../static/image/shys/jb05.jpg',
        '../../../../../static/image/shys/jb06.jpg',
        '../../../../../static/image/shys/jb07.jpg',
        '../../../../../static/image/shys/jb08.jpg',
      ],
      swiperListJn: [
        '../../../../../static/image/shys/jn01.jpg',
        '../../../../../static/image/shys/jn02.jpg',
      ],
      swiperListChs: [
        '../../../../../static/image/shys/chs01.jpg',
        '../../../../../static/image/shys/chs02.jpg',
        '../../../../../static/image/shys/chs03.jpg',
        '../../../../../static/image/shys/chs04.jpg',
        '../../../../../static/image/shys/chs05.jpg',
      ],
      swiperListZHzh: [
        '../../../../../static/image/shys/zhzh01.jpg',
        '../../../../../static/image/shys/zhzh02.jpg',
        '../../../../../static/image/shys/zhzh03.jpg',
        '../../../../../static/image/shys/zhzh04.jpg',
      ],
    }
  },
  mounted() {},
  methods: {
    handleClick(event) {
      switch (event.name) {
        case 'activeJb':
          this.initialIndexJb = 0
          break
        case 'activeJn':
          this.initialIndexJn = 0
          break
        case 'activeChs':
          this.initialIndexChs = 0
          break
        default:
          this.initialIndexZhzh = 0
          break
      }
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/ .el-tabs__item {
  font-size: 16px;
  font-weight: 550;
}
.introduction {
  // padding: 20px 0 90px 0;
  display: flex;
  align-items: center;
  height: 400px;
  // border: 2px dashed #e21818;
  .left {
    width: 800px;
    height: 401px;
    // border: 2px dashed #e21887;
  }
  .right {
    flex: 1;
    background-color: #e5f0f8;
    padding: 0px 24px 0;
    height: 401px;
    display: flex;
    align-items: center;
    // border: 2px dashed #e21887;
    // .right-content {
    //   border: 1px dashed #29e218;
    // }
    .title {
      text-align: center;
      height: 60px;
      line-height: 60px;
      font-size: 18px;
      color: #0068b7;
      font-weight: 700;
      margin-bottom: 10px;
    }

    .intro {
      line-height: 25px;
      color: #333333;
      margin-bottom: 10px;
      font-size: 16px;
    }
  }
}
.middle {
  padding: 90px 0;
  display: flex;
  align-items: center;
  height: 600px;
  // border: 1px dashed #c0e90b;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 2px dashed #e2bd18;
  // .middle-content {
  //   border: 1px dashed #1858e2;
  // }
}
.bottom {
  padding: 90px 8%;
  display: flex;
  align-items: center;
  height: 600px;
  // border: 1px dashed #e218d8;
  display: flex;
  justify-content: center;
  align-items: center;
  // border: 2px dashed #47e218;
  // .bottom-content {
  //   border: 1px dashed #1858e2;
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/website/aboutUs/component/lapintroduction.vue